import assetPath from '/app/packages/lebenslauf/articles/src/assets/yaroslav-olieinikov.jpg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')